import React, { useEffect, useState } from "react";
import { RankingTable } from "../../components/common/RankingTable";
import { 
  getCurrentSeason, 
  getListSeasons, 
  getGeneralRanking, 
  getGeneralRankingTop3 
} from "../../api";
import { GeneralRanking, Season, RankingStoricoTop3 } from "../../types";
import { userLabel } from "../../api";
import { ModalSelectSeason } from "../../components/common/ModalSelectSeason";
import { Button } from "../../components/common/Button";

export const GeneralRankingPage: React.FC = () => {
  const [seasons, setSeasons] = useState<Season[]>([]);
  const [selectedSeason, setSelectedSeason] = useState<Season | null>(null);
  const [seasonModal, setSeasonModal] = useState(false);
  const [ranking, setRanking] = useState<GeneralRanking[]>([]);
  const [page, setPage] = useState(0);
  const [displayedRanking, setDisplayedRanking] = useState<GeneralRanking[]>([]);
  const [rankingStorico, setRankingStorico] = useState<RankingStoricoTop3>({});
  const pageSize = 10;

  useEffect(() => {
    const fetchSeasons = async () => {
      const currentSeason = await getCurrentSeason();
      setSelectedSeason(currentSeason);

      const allSeasons = await getListSeasons();
      setSeasons(allSeasons);
    };
    fetchSeasons();
  }, []);

  useEffect(() => {
    if (!selectedSeason) return;
    const fetchRanking = async () => {
      const data = await getGeneralRanking(selectedSeason.id);
      setRanking(data);
      const dataTop3 = await getGeneralRankingTop3();
      setRankingStorico(dataTop3);
    };
    fetchRanking();
  }, [selectedSeason]);
  
  useEffect(() => {
    setPage(1)
  }, [ranking]);

  useEffect(() => {
    setDisplayedRanking(ranking.slice((page - 1) * pageSize, page * pageSize))
  }, [page, ranking]);

  return (
    <div className="p-4 max-w-4xl mx-auto">
      {/* Title e selezione stagione */}
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-bold">Classifica</h1>
        <Button
          variant="primary"
          onClick={() => setSeasonModal(true)}
        >
          {selectedSeason?.name || "Seleziona"}
        </Button>
      </div>

      {/* Ranking stagione selezionata */}
      <div className="my-6">
        <RankingTable type="general" data={displayedRanking} />
        {ranking.length > pageSize && (
          <div className="flex justify-center mt-2 space-x-2 flex-wrap">
            {Array.from({ length: Math.ceil(ranking.length / pageSize) }, (_, i) => (
              <Button
                key={i}
                variant={page === i + 1 ? "primary" : "secondary"}
                size="sm"
                onClick={() => setPage(i + 1)}
              >
                {i + 1}
              </Button>
            ))}
          </div>
        )}
      </div>

      {/* Albo d'oro */}
      <h2 className="text-xl font-semibold mb-4">Albo d'oro</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {seasons
          .filter((s) => s.is_ended)
          .map((s) => {
            let rankingRecord = rankingStorico[s.id];
            return (
              <div
                key={s.id}
                className={`p-4 border border-gray-300 rounded ${
                  selectedSeason?.id === s.id ? "bg-blue-100" : "bg-white"
                }`}
              >
                <h3 className="font-semibold mb-2">{s.name}</h3>
                { rankingRecord ? (
                  <ul>{rankingRecord.map((r, idx) => (
                      <li key={r.id} className="flex justify-between">
                        <span className="truncate max-w-xs">
                          {idx === 0
                            ? "🥇 "
                            : idx === 1
                            ? "🥈 "
                            : idx === 2
                            ? "🥉 "
                            : ""}
                          {userLabel(r.user)}
                        </span>
                        <span>{r.total_score}pt</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                    <p className="text-gray-500">Nessun dato</p>
                    
                )}
              </div>
            );
          })}
      </div>

      {/* Calcolo del ranking - spiegazione */}
      <div className="my-6">
        <p className="text-gray-500 text-xs font-light italic">
          Il ranking è calcolato in base ai risultati dei tornei e si aggiorna ogni volta che un torneo termina.<br />
          Il punteggio totale è la somma dei punteggi dei 7 migliori risultati.<br />
        </p>
      </div>

      {/* Modal per selezione stagione */}
      { seasonModal && ( 
        <ModalSelectSeason 
          currentSeason={selectedSeason!} 
          onSelect={(s) => { 
            setSelectedSeason(s);
            setSeasonModal(false);
          }} 
          onClose={() => setSeasonModal(false)} /> 
        )
      } 
    </div>
  );
};
